import { render, staticRenderFns } from "./createReviewModal.vue?vue&type=template&id=3d832649&scoped=true"
import script from "./createReviewModal.vue?vue&type=script&lang=js"
export * from "./createReviewModal.vue?vue&type=script&lang=js"
import style0 from "./createReviewModal.vue?vue&type=style&index=0&id=3d832649&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d832649",
  null
  
)

export default component.exports